import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchWarrantyReportList = (parameters = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/report/query${getUrlParameters(parameters)}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_WARRANTY_REPORT_LIST,
        ActionTypes.FETCHED_WARRANTY_REPORT_LIST,
        [
          ActionTypes.FETCHED_WARRANTY_REPORT_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchTasksList = (parameters = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/task/query${getUrlParameters(parameters)}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TASKS_LIST,
        ActionTypes.FETCHED_TASKS_LIST,
        [
          ActionTypes.FETCHED_TASKS_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const generateWarrantyReportFile =
  (reportType, parameters = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': `/warranties/report/${reportType}${getUrlParameters(parameters)}`,
          'authenticated': true,
          'types': [
            ActionTypes.FETCHING_WARRANTY_REPORT,
            ActionTypes.FETCHED_WARRANTY_REPORT,
            [
              ActionTypes.FETCHED_WARRANTY_REPORT_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'GET',
        })
      );
    };

export const clearWarrantyReportList = () => ({
  'type': ActionTypes.CLEAR_WARRANTY_REPORT_LIST,
});

export const clearWarrantyReportURLFile = () => ({
  'type': ActionTypes.CLEAR_WARRANTY_REPORT,
});
